class NavSearch {
	constructor(node, callback) {
		this.node = node;
		this.focusedClass = 'nav__search--focused';

		this.field = this.node.querySelector('.search-form__field');
		this.label = this.node.querySelector('.search-form__label');
		this.opener = this.node.querySelector('.search-form__open');
		this.closer = this.node.querySelector('.search-form__close');
		this.callback = callback.bind(this);
		this.documentFocusedClass = 'search-nav--focused';

		this._keyup = (e) => {
			if (e.which === 27) {
				this.blur();
			}
		};

		this._click = (e) => {
			if (!this.node.classList.contains(this.focusedClass)) {
				return;
			}

			let node = e.target;``
			while (node.parentNode) {
				if (node === this.node) {
					return;
				}
				node = node.parentNode;
			}

			this.blur();
		}

		this.opener.addEventListener('click', (e) => {
			e.preventDefault();

			if (this.node.classList.contains(this.focusedClass)) {
				this.blur();
			} else {
				this.focus();
			}
		});

		// this.field.addEventListener('blur', this.blur.bind(this));
		this.closer.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			this.blur();
		});
	}

	focus() {
		if (typeof this.callback === 'function') {
			let width = parseInt(this.callback());
			if (!isNaN(width) && width > 0) {
				this.label.style.width = `${width}px`;
			}
		}

		this.node.classList.add(this.focusedClass);
		this.field.focus();
		document.body.addEventListener('keyup', this._keyup);
		document.body.addEventListener('click', this._click);
		document.documentElement.classList.add(this.documentFocusedClass);
	}

	blur() {
		this.label.style.width = '';
		this.node.classList.remove(this.focusedClass);
		this.field.value = '';
		document.body.focus();
		document.body.removeEventListener('keyup', this._keyup);
		document.body.removeEventListener('click', this._click);
		document.documentElement.classList.remove(this.documentFocusedClass);
	}
}

export default NavSearch;